<template>
  <div class="google-signup-wrapper">
    <div class="google-signup" @click="connectWithGoogleAuth">
      <template v-if="!googleAuthLoading">
        <img
          src="./../../assets/icons/png/google_logo.png"
          class="google-logo"
        />Continue with Google
      </template>
      <Spinner v-else />
    </div>
    <div
      class="auth-error-msg"
      :class="{
        show: authErrorMsg !== '',
      }"
    >
      <span v-if="authErrorMsg == 'account_not_exist'">
        Your account doesn't exist. <br />
        Please signup from
        <span class="anchor-link" @click="setShowSignUp">here</span>
      </span>
      <span v-else>{{ authErrorMsg }}</span>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner'

export default {
  name: 'ConnectWithGoogleView',
  props: [
    'connectWithGoogleAuth',
    'authErrorMsg',
    'googleAuthLoading',
    'setShowSignUp',
  ],
  components: {
    Spinner,
  },
  data: function () {
    return {}
  },
  methods: {},
}
</script>
<style scoped lang="scss">
.auth-error-msg {
  font-size: 12px;
  text-align: center;
  margin: 5px 0;
  color: red;
  visibility: hidden;
  .anchor-link {
    color: #0fb3f0;
    cursor: pointer;
  }
}
.auth-error-msg.show {
  visibility: visible;
}
</style>
